export default __webpack_public_path__ + "static/media/Download.311ee185.svg";